import { useFeatureIsOn as _useFeatureIsOn, useFeatureValue as _useFeatureValue } from '@growthbook/growthbook-react';

import { AppFeatures } from '../../../src/client/types/__growthbook__/app-features';
import useIsAfterHydration from '../../../src/client/hooks/use-is-after-hydration';

// This hook reduces the boilerplate for useFeatureIsOn as you don't need to pass the AppFeatures type when calling it.
// https://docs.growthbook.io/lib/react#usefeatureisont
export const useFeatureIsOn = (id: keyof AppFeatures) => {
  const isAfterHydration = useIsAfterHydration();
  const isOn = _useFeatureIsOn(id);
  return isAfterHydration && isOn;
};

// useFeatureValue is not strongly typed with AppFeatures so this custom hook adds type safety to the feature id.
// It also reduces boilerplate by not needing to pass the default value type.
// https://docs.growthbook.io/lib/react#typescript-support
// eslint-disable-next-line
/** @public */
export const useFeatureValue = <K extends keyof AppFeatures>(id: K, defaultValue: AppFeatures[K]) => {
  const isAfterHydration = useIsAfterHydration();
  const value = _useFeatureValue(id, defaultValue);
  return (isAfterHydration && value) || defaultValue;
};
